import React from 'react';
import Logo from '@/components/layout/Logo';
import VacancyCardSkeleton from '@/components/homepage/VacancyCardSkeleton';

const skeletonBlock = 'rounded bg-slate-200 animate-pulse motion-reduce:animate-none';
const inputBlock = `${skeletonBlock} h-12 rounded-xl bg-slate-100`;

function FieldSkeleton({ labelWidth = 'w-28' }) {
  return (
    <div className="space-y-2">
      <div className={`${skeletonBlock} h-3 ${labelWidth}`} />
      <div className={inputBlock} />
    </div>
  );
}

function VacancyPreviewSkeleton() {
  return (
    <div className="hidden lg:block">
      <div className="mb-3 flex items-center gap-1.5 pl-1">
        <div className={`${skeletonBlock} h-1.5 w-1.5 rounded-full bg-indigo-200`} />
        <div className={`${skeletonBlock} h-3 w-24`} />
      </div>
      <VacancyCardSkeleton />
    </div>
  );
}

function WebsiteLoadingScreen() {
  return (
    <main
      className="min-h-screen bg-white px-4 sm:px-6 lg:px-8"
      aria-busy="true"
      aria-live="polite"
    >
      <div className="mx-auto flex min-h-screen max-w-7xl items-center py-16 sm:py-24 lg:py-32">
        <div className="w-full">
          <span className="sr-only">Studiebijbaan.nl wordt geladen</span>

          <div className="mb-10 flex justify-center lg:justify-start" aria-hidden="true">
            <Logo size={48} />
          </div>

          <div className="lg:grid lg:grid-cols-[1fr_384px] lg:items-center lg:gap-16" aria-hidden="true">
            <div className="text-center lg:text-left">
              <div className="mx-auto max-w-3xl space-y-3 lg:mx-0">
                <div className={`${skeletonBlock} mx-auto h-7 w-64 sm:h-10 sm:w-[30rem] lg:mx-0 lg:h-12 lg:w-[38rem]`} />
                <div className="flex flex-wrap items-center justify-center gap-2 lg:justify-start">
                  <div className={`${skeletonBlock} h-8 w-48 bg-indigo-200 sm:h-10 sm:w-72 lg:h-12 lg:w-96`} />
                  <div className={`${skeletonBlock} h-7 w-44 sm:h-10 sm:w-64 lg:h-12 lg:w-72`} />
                </div>
                <div className={`${skeletonBlock} mx-auto h-7 w-56 sm:h-9 sm:w-80 lg:mx-0 lg:h-10 lg:w-[26rem]`} />
              </div>

              <div className="mt-4 flex items-center justify-center gap-2 lg:justify-start">
                <div className={`${skeletonBlock} h-5 w-10`} />
                <div className={`${skeletonBlock} h-5 w-56`} />
              </div>

              <div className="relative mt-10">
                <div className="absolute -inset-1 rounded-xl bg-gradient-to-r from-orange-300 to-orange-400 opacity-20 blur-md animate-pulse" />
                <div className="relative rounded-xl border border-orange-300 bg-white p-5 text-left shadow-md sm:p-6">
                  <div className="grid grid-cols-1 gap-4 sm:grid-cols-3">
                    <FieldSkeleton labelWidth="w-36" />
                    <FieldSkeleton labelWidth="w-32" />
                    <FieldSkeleton labelWidth="w-28" />
                  </div>
                </div>
              </div>

              <div className="mt-10 lg:hidden">
                <div className="mb-3 flex items-center gap-1.5 pl-1">
                  <div className={`${skeletonBlock} h-1.5 w-1.5 rounded-full bg-indigo-200`} />
                  <div className={`${skeletonBlock} h-3 w-24`} />
                </div>
                <VacancyCardSkeleton />
              </div>
            </div>

            <VacancyPreviewSkeleton />
          </div>
        </div>
      </div>
    </main>
  );
}

export default WebsiteLoadingScreen;
